export const SITE_URL = "helpermemovemal.maximquiz.com";
export const GO_URL = "https://forms.gle/GsjjP9CKgYpWm8BS8";
